import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import LuciPropTypes from "../../propTypes/";
import AppSettings from "../../settings";
import { makeGetReplaceable, makeGetAutofillData } from "../../selectors/asset";
import { actions as assetActions } from "../../actions/asset";
import { TextArea, InputLabel, CloseButton } from "../../styled-components/";
import AutoCompleteInput from "../AutoCompleteInput";
import { isAutofillFillSelector } from "../../util/autofillUtils";
import { autosize } from "../../util/inputUtils";
import { parseDaliXml } from "../../util/daliUtils";
import localize from "../../util/localizeUtils";

const DEFAULT_THUMB = "images/blankImageReplaceable.png";

const ReplaceableImageContainer = styled.div``;

const OrderIndicatorIcon = styled.img`
  margin-left: 0.5rem;
`;

const MaxCounter = styled.div`
  display: inline-block;
  padding: 0.25rem;
  vertical-align: top;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 8rem;
`;
/* eslint-disable */
const ReplaceableImage = styled.img`
  min-width: 8rem;
  max-width: 8rem;
  background-color: ${props => props.theme.editor.replaceableImage.background};
  background-image: url(${props =>
    props.type === "video"
      ? "images/movieIndicator.png"
      : "images/imageIndicator.png"});
  background-repeat: no-repeat;
  background-position: right bottom;
  transition: box-shadow 200ms ease-out;
  border: 1px solid ${props => props.theme.border};
  box-shadow: ${props =>
    props.selected
      ? `0 0 10px 3px ${props.theme.editor.replaceableImage.boxShadow}`
      : "0"};
`;
/* eslint-enable */

const ClearImageButton = styled(CloseButton)`
  display: ${props => (props.visible ? "block" : "none")};
  position: absolute;
  top: 1px;
  right: 1px;
  padding: 0 0.25rem;
  background-color: ${props => props.theme.background};
`;

const InputRow = styled.div`
  padding-bottom: 0.25rem;
`;

const LinkButton = styled.div`
  background-color: #fefefe;
  border: 1px outset grey;
  display: inline-block;
  margin-left: 0.25rem;
  padding: 0.11rem 0.2rem;
  verticalalign: top;
`;

const getDisplayName = replaceable => {
  const { name, properties } = replaceable;
  return properties && properties.displayName ? properties.displayName : name;
};

class ReplaceableField extends React.Component {
  constructor() {
    super();
    this.state = {
      hasCharacterLimit: false,
      characterCount: -1,
      characterLimit: -1,
      imgSrc: DEFAULT_THUMB,
      value: "",
      autofillData: []
    };
  }

  addListeners = () => {
    if (this.props.onDoubleClick) {
      // only handles media replaceables double click
      $(this.replaceableImage)
        .on("click", this.handleClick)
        .on("dblclick", this.props.onDoubleClick);
    }
  };

  removeListeners = () => {
    if (this.props.onDoubleClick) {
      // only handles media replaceables double click
      $(this.replaceableImage)
        .off("click", this.handleClick)
        .off("dblclick", this.props.onDoubleClick);
    }
  };

  componentDidMount() {
    const characterLimit =
      this.props.replaceable.properties["max length"] === undefined ||
      this.props.replaceable.properties["max length"] === null
        ? -1
        : this.props.replaceable.properties["max length"];
    this.setIntitialState(
      characterLimit,
      this.props.replaceable.value,
      this.props.replaceable.url
    );
    if (this.textBox) {
      autosize(this.textBox);
    }
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.replaceable && this.props.replaceable) {
      const thumbnailUrl = nextProps.replaceable
        ? nextProps.replaceable.url
        : "";
      const oldThumbnailUrl = this.props.replaceable
        ? this.props.replaceable.url
        : "";
      if (oldThumbnailUrl !== thumbnailUrl) {
        const newThumb = this.cleanImageUrl(thumbnailUrl) || DEFAULT_THUMB;
        if (this.state.imgSrc !== newThumb) {
          this.setState({ imgSrc: newThumb });
        }
      }
      if (
        nextProps.replaceable.value !== this.props.replaceable.value &&
        nextProps.replaceable.value !== this.state.value
      ) {
        this.setState({ value: nextProps.replaceable.value });
      }
    }
  }

  onDrop = event => {
    event.preventDefault();
    let data = null;
    if (event.dataTransfer.types.includes("cf_proximitychyronstill")) {
      data = parseDaliXml(
        event.dataTransfer.getData("cf_proximitychyronstill")
      );
    } else if (event.dataTransfer.types.includes("text/plain")) {
      const eventData = event.dataTransfer.getData("text/plain");
      try {
        data = JSON.parse(eventData);
        data.dataSrc = "luci";
      } catch (e) {
        /* Silently fail */
      }
    }

    if (data && data.dataSrc === "luci") {
      this.setState({
        imgSrc: data.thumbnailUrl
          ? `${AppSettings.camioServer}${data.thumbnailUrl}`
          : DEFAULT_THUMB
      });
      if (event.target.value !== this.props.replaceable.value) {
        this.props.updateReplaceableValue({
          id: this.props.replaceableId,
          name: this.props.replaceable.name,
          url: data.thumbnailUrl,
          type: this.props.replaceable.type,
          value: data.id,
          provider: data.provider
        });
      }
    } else if (data && data.dataSrc === "dali") {
      this.props.createDeficientAsset(this.props.replaceableId, {
        guid: data.guid,
        type: data.type,
        title: data.title,
        name: this.props.replaceable.name
      });
    }
  };

  onTextFocus = () => {
    if (this.textBox) {
      this.textBox.select();
    }
  };

  onDragOver = event => {
    if (
      (this.props.assetType === this.props.replaceable.type &&
        (!this.props.replaceable.properties.restrictAssetCategory ||
          (this.props.replaceable.properties.restrictAssetCategory &&
            this.props.categoryId ===
              this.props.replaceable.properties.assetCategory))) ||
      event.dataTransfer.types.includes("cf_proximitychyronstill")
    ) {
      event.preventDefault();
      return false;
    }
  };

  setIntitialState(characterLimit, value, imgSrc) {
    this.setState({
      hasCharacterLimit: characterLimit > 0,
      characterLimit,
      characterCount: value ? value.length : 0,
      value,
      imgSrc: this.cleanImageUrl(imgSrc) || DEFAULT_THUMB
    });
  }

  cleanImageUrl = thumbnailUrl => {
    if (thumbnailUrl && !thumbnailUrl.startsWith("images/")) {
      if (thumbnailUrl.includes("http://")) {
        return thumbnailUrl;
      } else if (thumbnailUrl.startsWith("/")) {
        return `${AppSettings.camioServer}${thumbnailUrl.substring(1)}`;
      }
      return `${AppSettings.camioServer}${thumbnailUrl}`;
    }
    return thumbnailUrl;
  };

  handleTextChange = event => {
    this.setState({
      value: event.target.value,
      characterCount: event.target.value.length
    });
  };

  handleToggleLinked = () => {
    const { id } = this.props.replaceable;
    this.props.toggleReplaceableUseDataSource(id);
  };

  updateValue = event => {
    if (event.target.value !== this.props.replaceable.value) {
      this.props.updateReplaceableValue({
        id: this.props.replaceable.id,
        name: this.props.replaceable.name,
        type: this.props.replaceable.type,
        value: event.target.value
      });
    }
  };

  updateAutofillValue = (selectedIndex, name, value, autofillGroup) => {
    this.props.updateReplaceableValue(
      selectedIndex,
      name,
      value,
      autofillGroup
    );
  };

  resetReplaceable = event => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      imgSrc: DEFAULT_THUMB
    });
    this.props.updateReplaceableValue({
      id: this.props.replaceableId,
      name: this.props.replaceable.name,
      type: this.props.replaceable.type,
      url: null,
      value: null
    });
  };

  handleClick = () => {
    const { type, properties, selected } = this.props.replaceable;
    if (!selected) {
      this.props.selectReplaceable(
        this.props.replaceableId,
        properties.assetCategory,
        properties.restrictAssetCategory
      );
    }
    this.props.onClick(
      type,
      properties.assetCategory,
      properties.restrictAssetCategory
    );
  };

  renderTextInput() {
    const { id, name } = this.props.replaceable;
    const { characterLimit, value } = this.state;
    return (
      <TextArea
        ref={ref => {
          this.textBox = ref;
        }}
        id={`${id}-${name}`}
        maxLength={characterLimit > 0 ? characterLimit : ""}
        rows="1"
        cols="22"
        onFocus={this.onTextFocus}
        onClick={this.handleClick}
        onChange={this.handleTextChange}
        onBlur={this.updateValue}
        value={value}
      />
    );
  }

  renderTextReplaceable() {
    const { id, name, properties } = this.props.replaceable;
    const { hasCharacterLimit, characterLimit, characterCount } = this.state;
    const displayName = getDisplayName(this.props.replaceable);

    let textInput = this.renderTextInput();
    if (
      isAutofillFillSelector(this.props.replaceable) &&
      this.props.autofillData.length > 0
    ) {
      textInput = this.renderAutofillTextInput();
    } else if (properties.dataSource) {
      textInput = this.renderDataTargetTextInput();
    }
    return (
      <InputRow>
        <InputLabel htmlFor={`${id}-${name}`}>{displayName}</InputLabel>
        <div style={{ display: "inline-block" }}>{textInput}</div>
        <MaxCounter>
          {hasCharacterLimit ? characterLimit - characterCount : ""}
        </MaxCounter>
      </InputRow>
    );
  }

  renderAutofillTextInput() {
    const { id, name, properties } = this.props.replaceable;
    const { value } = this.state;
    return (
      <AutoCompleteInput
        id={`${id}-${name}`}
        name={name}
        autofillGroup={properties.autofillGroup}
        data={this.props.autofillData}
        onClick={this.handleClick}
        onChange={this.updateAutofillValue}
        value={value}
        width="11.2rem"
        loading={this.props.autofillLoading}
      />
    );
  }

  renderDataTargetTextInput() {
    const { id, name, properties } = this.props.replaceable;
    const { value } = this.state;
    const iconToolTip = properties.usesDataSource
      ? localize("linkedDataSourceTooltip")
      : localize("unlinkedDataSourceTooltip");
    const iconSrc = properties.usesDataSource
      ? "images/link.png"
      : "images/broken-link.png";
    return (
      <div>
        <div style={{ display: "inline-block", verticalAlign: "top" }}>
          <TextArea
            ref={ref => {
              this.textBox = ref;
            }}
            id={`${id}-${name}`}
            disabled={properties.usesDataSource}
            rows="1"
            cols="22"
            value={value}
            onChange={this.handleTextChange}
            onBlur={this.updateValue}
          />
        </div>
        <LinkButton onClick={this.handleToggleLinked}>
          <img alt={iconToolTip} src={iconSrc} title={iconToolTip} />
        </LinkButton>
      </div>
    );
  }

  renderMediaReplaceable() {
    const { name, properties, type } = this.props.replaceable;
    const { selected } = this.props;
    const displayName =
      properties && properties.displayName ? properties.displayName : name;
    return (
      <div>
        <div>
          <div>
            {/* eslint-disable */}
            <label>
              {displayName}
              <OrderIndicatorIcon
                src="images/orderIndicator.png"
                style={{ display: "none" }}
              />
            </label>
            {/* eslint-enable */}
          </div>
        </div>
        <div>
          <div>
            <ReplaceableImageContainer
              ref={r => {
                this.replaceableImage = r;
              }}
              draggable
              onDrop={this.onDrop}
              onDragOver={this.onDragOver}
              onClick={this.handleClick}
            >
              <ImageContainer>
                <ReplaceableImage
                  selected={selected}
                  src={this.state.imgSrc}
                  type={type}
                />
                <ClearImageButton
                  visible={this.state.imgSrc !== DEFAULT_THUMB}
                  onClick={this.resetReplaceable}
                >
                  &times;
                </ClearImageButton>
              </ImageContainer>
            </ReplaceableImageContainer>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { type } = this.props.replaceable;
    switch (type) {
      case "image":
      case "video":
        return this.renderMediaReplaceable();
      case "text":
        return this.renderTextReplaceable();
      default:
        return this.renderMediaReplaceable();
    }
  }
}

ReplaceableField.defaultProps = {
  onClick: () => {},
  onDoubleClick: null,
  updateReplaceableValue: () => {}
};

ReplaceableField.propTypes = {
  replaceableId: PropTypes.string.isRequired,
  replaceable: LuciPropTypes.Replaceable.isRequired,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  updateReplaceableValue: PropTypes.func,
  selectReplaceable: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  autofillLoading: PropTypes.bool.isRequired,
  // eslint-disable-next-line
  autofillData: PropTypes.arrayOf(PropTypes.string).isRequired,
  assetType: PropTypes.string.isRequired,
  categoryId: PropTypes.number.isRequired,
  createDeficientAsset: PropTypes.func.isRequired,
  toggleReplaceableUseDataSource: PropTypes.func.isRequired
};

const makeMapStateToProps = () => {
  const getReplaceable = makeGetReplaceable();
  const getAutofillData = makeGetAutofillData();
  const mapStateToProps = (state, props) => ({
    replaceable: getReplaceable(state, props.replaceableId),
    selected: state.asset.selectedReplaceableId === props.replaceableId,
    autofillLoading: state.asset.autofillLoading,
    autofillData: getAutofillData(state, props.replaceableId),
    assetType: state.content.assetType,
    categoryId: state.content.categoryId
  });
  return mapStateToProps;
};

const mapActionCreators = {
  selectReplaceable: assetActions.selectReplaceable,
  createDeficientAsset: assetActions.createDeficientAsset,
  toggleReplaceableUseDataSource: assetActions.toggleReplaceableUseDataSource
};

export default connect(
  makeMapStateToProps,
  mapActionCreators
)(ReplaceableField);



// WEBPACK FOOTER //
// ./app/components/Editor/ReplaceableField.js